import React from "react"

export default function Download2() {
   return (
      <svg fill="none" viewBox="0 0 25 25" height="25" width="25" xmlns="http://www.w3.org/2000/svg">
         <circle cx="12.0332" cy="12.124" r="12" fill="#D6D6D6" />
         <g clipPath="url(#clip0_167_7027)">
            <path d="M15.3703 11.5275C15.3019 11.3765 15.1518 11.2803 14.9864 11.2803H13.2989V5.7959C13.2989 5.56302 13.1099 5.37402 12.877 5.37402H11.1895C10.9566 5.37402 10.7676 5.56302 10.7676 5.7959V11.2803H9.08013C8.91475 11.2803 8.76457 11.3773 8.69622 11.5275C8.62704 11.6785 8.65404 11.8549 8.76288 11.9797L11.716 15.3547C11.7962 15.4467 11.9118 15.499 12.0333 15.499C12.1548 15.499 12.2703 15.4459 12.3505 15.3547L15.3036 11.9797C15.4133 11.8557 15.4386 11.6785 15.3703 11.5275Z" fill="white" />
            <path d="M16.6738 14.6553V17.1865H7.39258V14.6553H5.70508V18.0303C5.70508 18.4969 6.08308 18.874 6.54883 18.874H17.5176C17.9842 18.874 18.3613 18.4969 18.3613 18.0303V14.6553H16.6738Z" fill="white" />
         </g>
         <defs>
            <clipPath id="clip0_167_7027">
               <rect width="13.5" height="13.5" fill="white" transform="translate(5.2832 5.37402)" />
            </clipPath>
         </defs>
      </svg>
   )
}
